import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { UnavailableHoursSettingsModel } from '@/models/ps-management/availability-hours.model';

export default class GetGeoPaymentMethodAvailabilityHoursRequest
  extends ApiResourceMethod<UnavailableHoursSettingsModel> {
  public perform(paymentMethodId: string): Promise<UnavailableHoursSettingsModel> {
    return this.performer.requestWithMapper(
      { url: `${paymentMethodId}/unavailableHours` },
      (
        { data }: BaseResponse<UnavailableHoursSettingsModel>,
      ): UnavailableHoursSettingsModel => data,
    );
  }
}
